import { render, staticRenderFns } from "./btn-uploader.vue?vue&type=template&id=375f19a0&scoped=true&"
import script from "./btn-uploader.vue?vue&type=script&lang=js&"
export * from "./btn-uploader.vue?vue&type=script&lang=js&"
import style0 from "./btn-uploader.vue?vue&type=style&index=0&id=375f19a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f19a0",
  null
  
)

export default component.exports